import { PageHeader } from "../components/PageHeader";
import { ProductCard } from "../components/ProductCard";
import { ConnectState } from "../components/ConnectState";
import { Reveal } from "../components/Reveal";
import { useProducts } from "../lib/api";
import { PreviewBanner } from "../components/PreviewBanner";

export default function Drops() {
  const state = useProducts({ first: 24, sort: "newest" });

  return (
    <div>
      <PageHeader
        eyebrow="New drops — Latest first"
        title="Fresh off the trail"
        description="The newest TRAILNONE releases, straight from the store. Limited runs — when they're gone, they're gone."
      />
      <div className="px-5 py-12 sm:px-10 lg:px-16">
        {state.loading ? (
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] animate-pulse bg-secondary" />
            ))}
          </div>
        ) : !state.connected && state.products.length === 0 ? (
          <Reveal>
            <ConnectState />
          </Reveal>
        ) : state.products.length === 0 ? (
          <p className="border border-border p-16 text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
            No drops live yet — publish products in Shopify to fill this page
          </p>
        ) : (
          <>
            {!state.connected && <PreviewBanner />}
            <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
              {state.products.map((p, i) => (
                <ProductCard key={p.id} product={p} index={i % 8} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
